import React from "react";
import Card from "react-bootstrap/Card";
import { AiOutlineArrowRight } from "react-icons/ai";
import ScrollReveal from "../ScrollReveal/ScrollReveal";

const interests = [
  "Writing and sharing technical ideas",
  "Reading to sharpen judgment and perspective",
  "Travel, exploration, and observing good design",
  "Games and systems that reward strategy",
];

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p>
            I&apos;m <span className="primary-header">Shankar Kharel</span>, a
            backend-focused software engineer from Nepal, currently based in
            Balkumari, Lalitpur. I build production systems across web and
            mobile products, with the deepest focus on Node.js, TypeScript, and
            NestJS.
          </p>
          <p>
            My work includes modular backend design, secure REST APIs,
            webhook-driven integrations, relational database design, and
            end-to-end ownership from architecture to production support. I
            also lead teams and help translate product requirements into stable
            engineering delivery.
          </p>
          <ul className="activity-list">
            {interests.map((item) => (
              <ScrollReveal
                as="li"
                className="about-activity"
                key={item}
                delay={interests.indexOf(item) * 70}
                distance={16}
              >
                <AiOutlineArrowRight /> {item}
              </ScrollReveal>
            ))}
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
